import { render } from "./Landing.vue?vue&type=template&id=229b4386&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"

import "./Landing.vue?vue&type=style&index=0&id=229b4386&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\JAN-2211154-DEV\\landing-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229b4386"]])

export default __exports__